/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import Styles from '../../css/ServicerEscrowAnalysis.module.css';
import { getTimestampAsDate } from '../../common/UtilityFunctions';
import { useCallback } from 'react';
import { isStrEmptyOrNull } from '../../common/UtilityFunctions';
import { EscrowAnalysisViews, useServicerEscrowAnalysisContext } from '../../contexts/ServicerEscrowAnalysisContext';

type EscrowNumbersTableProps = {
  effectiveDate: string;
  currentEscrowBalance: string;
  estimatedBalance: string;
  projectedBalance: string;
  shortSurplus: string;
  prinInt: string;
  newEscrowPayment: string;
  newMonthlyPayment: string;
  newEscrowPaymentWOShortSurplus: string;
  paymentChange: string;
  refund: string;
  refundNotApplicable: string;
  escrowAnalysisTiCushion?: number;
  runDate?: string;
  newMonthlyPaymentWOShortSurplus: string;
  escrowShortageRepayMonths: string;
  pitiDiff: string;
  newMonthlyImpound: string;
};

const EscrowNumbersTable = (props: EscrowNumbersTableProps) => {
  const { viewToShow } = useServicerEscrowAnalysisContext();

  const {
    effectiveDate,
    currentEscrowBalance,
    estimatedBalance,
    projectedBalance,
    shortSurplus,
    prinInt,
    newEscrowPayment,
    newMonthlyPayment,
    paymentChange,
    escrowAnalysisTiCushion,
    runDate,
    escrowShortageRepayMonths,
    pitiDiff,
    newMonthlyImpound,
  } = props;

  const trow = (label: string, value) => {
    return (
      <TableRow>
        <TableCell className={Styles.smallTableLabel}>{label}</TableCell>
        <TableCell align='right'>{value}</TableCell>
      </TableRow>
    );
  };

  let shortagePresent = parseFloat(shortSurplus) < 0;

  return (
    <>
      <div className={Styles.smalltable}>
        <Table size='small' className={Styles.taxTable}>
          <TableBody>
            {viewToShow === EscrowAnalysisViews.AEA_HISTORY_VIEW && trow('Run Date', runDate)}
            {trow('Effective Date', effectiveDate)}
            {viewToShow === EscrowAnalysisViews.AEA_HISTORY_VIEW && trow('Cushion Months', escrowAnalysisTiCushion)}
            {viewToShow === EscrowAnalysisViews.AEA_HISTORY_VIEW && trow('Shortage Months', escrowShortageRepayMonths)}
            {trow('Current Escrow Balance', currentEscrowBalance)}
            {trow('Estimated Escrow Balance', estimatedBalance)}
            {trow('Projected Escrow Balance', projectedBalance)}
            {trow(shortagePresent ? 'Shortage' : 'Surplus', shortSurplus)}
          </TableBody>
        </Table>
      </div>

      <div className={Styles.smalltable}>
        <Table size='small' className={Styles.taxTable}>
          <TableBody>
            {
              <>
                {trow('Prin & Int', prinInt)}
                {trow('New escrow payment', newMonthlyImpound)}
                {parseFloat(paymentChange) > 0 && trow('Monthly Shortage', paymentChange)}
                {parseFloat(paymentChange) < 0 && trow('Monthly Surplus', paymentChange)}
                {trow('New monthly payment', newMonthlyPayment)}
                {trow('Payment Change', pitiDiff)}
              </>
            }
          </TableBody>
        </Table>
      </div>
    </>
  );
};

export default EscrowNumbersTable;
